/* eslint-disable consistent-return */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { LEARNING_ASSET_TYPES, SECTION_ITEM_TYPES, RICH_TEXT_LAYOUTS } from '../../../../../shared/Constants';

class BaseDefaultFieldsForm extends Component {
    static propTypes = {
        type: PropTypes.string,
        changeFormValue: PropTypes.func,
        getFormValue: PropTypes.func
    };

    static startTypes = [
        { label: 'Start', value: 'start' },
        { label: 'Match', value: 'match' }
    ];

    static dataScopeTypes = [
        { label: 'Solo', value: 'solo' },
        { label: 'Group', value: 'group' }
    ];

    static transitionTypes = [
        { label: 'Slide', value: 'slide' },
        { label: 'Fade', value: 'fade' }
    ];

    static typeOptions = [
        { name: 'Content', topLevel: true, disabled: true, label: <div>Content</div> },
        { name: 'Dynamic Rich Text', section: 'Content', label: <div>Dynamic Rich Text</div> },
        { name: 'File Upload', section: 'Content', label: <div>File Upload</div> },
        { name: 'Questions', topLevel: true, disabled: true, label: <i>--- Questions ---</i> },
        { name: 'Short Essay', section: 'Questions', label: <div>Short Essay</div> },
        { name: 'Choose One', section: 'Questions', label: <div>Choose One</div> },
        { name: 'Choose Many', section: 'Questions', label: <div>Choose Many</div> },
        { name: 'Choose One Path', section: 'Questions', label: <div>Choose One Path</div> },
        { name: 'Likert', section: 'Questions', label: <div>Likert</div> },
        { name: 'This or That Permutation', section: 'Questions', label: <div>This or That Permutation</div> },
        { name: 'Wrap Up', section: 'Questions', label: <div>Wrap Up</div> },
        { name: 'Results', topLevel: true, disabled: true, label: <i>--- Results ---</i> },
        { name: 'Short Essay Results', section: 'Results', label: <div>Short Essay Results</div> },
        { name: 'This or That Chart', section: 'Results', label: <div>This or That Chart</div> },
        { name: 'This or That Results', section: 'Results', label: <div>This or That Results</div> },
        { name: 'Show Previous Answers', section: 'Results', label: <div>Show Previous Answers</div> },
        {
            name: 'Show Previous Answers and Choose One',
            section: 'Questions',
            label: <div>Show Previous Answers & Choose One</div>
        },
        { name: 'Review Previous Activities', section: 'Results', label: <div>Review Previous Activities</div> },
        { name: 'Advanced', topLevel: true, disabled: true, label: <div>Advanced</div> },
        { name: 'Invite Users', section: 'Advanced', label: <div>Invite Users</div> },
        { name: 'End Session', section: 'Advanced', label: <div>End Session</div> },
        { name: 'Quiz', topLevel: true, disabled: true, label: <div>Quiz</div> },
        { name: 'Choose One Quiz', section: 'Quiz', label: <div>Choose One Quiz</div> },
        { name: 'Quiz Results', section: 'Quiz', label: <div>Quiz Results</div> },
        { name: 'Nudge', topLevel: true, disabled: true, label: <div>Nudge</div> },
        { name: 'Email', section: 'Nudge', label: <div>Email</div> },
        { name: 'Onscreen', section: 'Nudge', label: <div>Onscreen</div> }
    ];

    static welcomeTypeOptions = [
        { name: 'Content', topLevel: true, disabled: true, label: <div>Content</div> },
        { name: 'Dynamic Rich Text', section: 'Content', label: <div>Dynamic Rich Text</div> },
        { name: 'Questions', topLevel: true, disabled: true, label: <i>--- Questions ---</i> },
        { name: 'Choose One', section: 'Questions', label: <div>Choose One</div> },
        { name: 'Choose One Path', section: 'Questions', label: <div>Choose One Path</div> },
        { name: 'Choose Many', section: 'Questions', label: <div>Choose Many</div> },
        { name: 'Likert', section: 'Questions', label: <div>Likert</div> }
    ];

    static singlePageActivityTypeOptions = [
        { name: 'Content', topLevel: true, disabled: true, label: <div>Content</div> },
        { name: 'Dynamic Rich Text', section: 'Content', label: <div>Dynamic Rich Text</div> },
        { name: 'Questions', topLevel: true, disabled: true, label: <i>--- Questions ---</i> },
        { name: 'Short Essay', section: 'Questions', label: <div>Short Essay</div> },
        { name: 'Likert', section: 'Questions', label: <div>Likert</div> },
        { name: 'Results', topLevel: true, disabled: true, label: <i>--- Results ---</i> },
        { name: 'Show Previous Answers', section: 'Results', label: <div>Show Previous Answers</div> },
        { name: 'Choose One', section: 'Questions', label: <div>Choose One</div> },
        { name: 'Choose One Path', section: 'Questions', label: <div>Choose One Path</div> },
        { name: 'Choose Many', section: 'Questions', label: <div>Choose Many</div> },
        { name: 'Wrap Up', section: 'Questions', label: <div>Wrap Up</div> },
    ];

    static mobileTypeOptions = [
        { name: 'Likert', section: 'Questions', label: <div>Likert</div> },
        { name: 'Dynamic Rich Text', section: 'Content', label: <div>Dynamic Rich Text</div> },
        { name: 'Short Essay', section: 'Questions', label: <div>Short Essay</div> },
        { name: 'Choose One', section: 'Questions', label: <div>Choose One</div> },
        { name: 'Choose Many', section: 'Questions', label: <div>Choose Many</div> }
    ];

    /**
     *
     * @param {string} value
     * @return {string}
     */
    _startsOnParser = (value) => (!isEmpty(value) ? value.replace('Day ', '') : '');

    /**
     *
     * @param {number} number
     * @return {string}
     */
    _startsOnFormatter = (number) => `Day ${number}`;

    /**
     *
     * @param {String} memberReference
     * @param event
     * @param {String} newValue
     * @param {String} previousValue
     */
    _onSectionItemTypeChange = (memberReference, event, newValue, previousValue) => {
        const { changeFormValue } = this.props;

        // if the new value does not match the existing value, flush the content property on the sectionItem
        // so we dont store old properties
        if (newValue !== previousValue) {
            const disabled = this._getDisabled(memberReference, newValue);

            if (disabled.isRequired) {
                changeFormValue({ field: `${memberReference}.isRequired`, value: false });
            }

            // set default values
            if (newValue === 'This or That Permutation') {
                const displayType = this.props.getFormValue(`${memberReference}.content.displayType`);
                if (isEmpty(displayType)) {
                    return changeFormValue({ field: `${memberReference}.content.displayType`, value: 'radio' });
                }
            }

            if (newValue === 'Email') {
                const templateType = this.props.getFormValue(`${memberReference}.content.emailTemplate`);
                if (isEmpty(templateType)) {
                    return changeFormValue({
                        field: `${memberReference}.content.emailTemplate`,
                        value: 'purple-rockets'
                    });
                }
            }

            if (newValue === 'Feedback Invite') {
                return changeFormValue({ field: `${memberReference}.targetParticipantRole`, value: 'employee' });
            }

            if (newValue === 'Feedback') {
                return changeFormValue({ field: `${memberReference}.targetParticipantRole`, value: 'all' });
            }

            if (newValue === 'Short Essay') {
                return changeFormValue({ field: `${memberReference}.content.hideCharacterCount`, value: true });
            }

            if (
                (newValue === 'Choose One' || newValue === 'Choose Many') &&
                !(previousValue === 'Choose One' || previousValue === 'Choose Many')
            ) {
                return changeFormValue({ field: `${memberReference}.content.displayType`, value: 'radio' });
            }

            if (
                (newValue === 'Choose One' || newValue === 'Choose Many') &&
                (previousValue === 'Choose One' || previousValue === 'Choose Many')
            ) {
                const displayType = this.props.getFormValue(`${memberReference}.content.displayType`);
                return changeFormValue({
                    field: `${memberReference}.content.displayType`,
                    value: displayType || 'radio'
                });
            }

            if (newValue === 'Likert' && (previousValue === 'Choose One' || previousValue === 'Choose Many')) {
                const displayType = this.props.getFormValue(`${memberReference}.content.displayType`) || 'radio';
                const description = this.props.getFormValue(`${memberReference}.content.description`) || '';
                return changeFormValue({ field: `${memberReference}.content`, value: { displayType, description } });
            }

            if (newValue === 'Wrap Up') {
                changeFormValue({
                    field: `${memberReference}.content.blocks.0.layout`,
                    value: RICH_TEXT_LAYOUTS.TOP_TEXT_ONLY
                });
                return changeFormValue({ field: `${memberReference}.name`, value: 'Wrap Up' });
            }

            return changeFormValue({ field: `${memberReference}.content`, value: {} });
        }
    };

    isCourseType = () => {
        const { type } = this.props;
        return (
            type === LEARNING_ASSET_TYPES.TRACK ||
            type === LEARNING_ASSET_TYPES.IMPACT_PROJECT
        );
    };

    /**
     *
     * @param memberReference
     * @param sectionItemType
     * @return {{}}
     * @private
     */
    _getDisabled = (memberReference, sectionItemType) => {
        const { type } = this.props;
        const disabled = {};
        if (SECTION_ITEM_TYPES.isReadOnly(sectionItemType)) {
            disabled.isRequired = true;
        }
        if (SECTION_ITEM_TYPES.isNudgeType(sectionItemType)) {
            disabled.transition = true;
            disabled.isRequired = true;
            disabled.dataScope = true;
        }

        // disable for video section items
        if (type === LEARNING_ASSET_TYPES.VIDEO) {
            disabled.isVideo = true;
        }
        return disabled;
    };

    /**
     *
     * @return {Array}
     * @private
     */
    _buildTargetParticipantRoleDataSource = (isSolo = false) => {
        const dataSource = [];

        dataSource.push({ label: 'All', value: 'all' });
        if (isSolo) {
            return dataSource;
        }
        const participants = this.props.getFormValue('participants') || [];

        const participantDict = {
            employee: { label: 'Employee', value: 'employee' },
            socialentrepreneur: { label: 'Social Entrepreneur', value: 'socialentrepreneur' },
            colleague: { label: 'Colleague', value: 'colleague' },
            teammate: { label: 'Teammate', value: 'teammate' },
            facilitator: { label: 'Facilitator', value: 'facilitator' },
        };
        const lookup = {};
        participants.forEach((participant) => {
            // we ignore the 'all' participant role since it duplicated by our local catch "All" option
            if (participant.type !== 'all' && !(participant.type in lookup)) {
                lookup[participant.type] = participant.type;

                if (participantDict[participant.type]) {
                    dataSource.push(participantDict[participant.type]);
                } else if (participant.id && participant.type) {
                    dataSource.push({ label: participant.type, value: participant.type });
                }
            }
        });
        return dataSource;
    };

    /**
     *
     * @param {Object} option
     * @param {string} option.name
     * @param {boolean} option.topLevel
     * @private
     */
    _renderValue = (option) => {
        if (option.topLevel) {
            return <span>{option.name}</span>;
        }
        return <span>&nbsp;&nbsp;&nbsp;{option.name}</span>;
    };
}

export default BaseDefaultFieldsForm;
